import { RcoSplitStep } from "@redotech/redo-model/advanced-flow/advanced-flow-db-parser";
import { FrontendStepType, PartialFlowStep, PartialWithRequiredType } from "..";
import { FlowInProgress } from "../../flow-editor";
import { RcoSplitEditInspector } from "./edit-inspector";
import { RcoSplitViewInspector } from "./view-inspector";

function RcoSplitInspector({
  step,
  setStep,
  onClose,
  setAutomation,
  readonly = false,
  steps,
}: {
  step: PartialWithRequiredType<RcoSplitStep>;
  steps: PartialFlowStep[];
  setStep: (step: PartialWithRequiredType<RcoSplitStep>) => void;
  onClose?: () => void;
  setAutomation?: React.Dispatch<React.SetStateAction<FlowInProgress | null>>;
  readonly?: boolean;
}) {
  if (readonly) {
    return <RcoSplitViewInspector onClose={onClose} step={step} />;
  } else {
    return (
      <RcoSplitEditInspector
        onClose={onClose}
        setAutomation={setAutomation}
        setStep={setStep}
        step={step}
        steps={steps}
      />
    );
  }
}

export const rcoSplitStepType: FrontendStepType<
  PartialWithRequiredType<RcoSplitStep>
> = {
  type: "custom",
  valid: (step) =>
    !!step.splitId &&
    !!step.name &&
    !!step.metricToOptimize &&
    !!(step.treatments && step.treatments.length >= 2) &&
    step.treatments.every(
      (treatment) =>
        !!treatment.treatmentId &&
        !!treatment.name &&
        !!treatment.weight &&
        !!treatment.nextId,
    ),
  selectable: (_) => true,
  customInspector: (args) => {
    return RcoSplitInspector({
      step: args.step,
      setStep: args.setStep,
      onClose: args.onClose,
      setAutomation: args.setAutomation,
      readonly: args.readonly,
      steps: args.steps,
    });
  },
};
